<template>
  <b-container>
    <b-col class="created-company-details-holder">
      <div class="created-company-details created-company-details-vali-hollow-logo">
        <h1 class="text-left mt-2 created-company-title">
          {{ this.createdCompany.name }}
        </h1>
        <b-row class="d-flex justify-content-between">
          <b-col cols="4" class="ml-1">
            Ellenőrizze tervezett vállalkozásának adatait és lépjen tovább a Forrástérképre.
          </b-col>
          <b-col class="d-flex justify-content-end">
            <b-button class="btn mt-2 link-button btn-primary" @click="goToEditImaginaryCompany">
              Adatok szerkesztése
            </b-button>
            <b-button class="btn ml-3 mt-2 link-button btn-primary" variant="primary" @click="goToFundMap">
              Tovább a Forrástérképre
            </b-button>
          </b-col>
        </b-row>

        <b-row cols="2">
          <b-col>Fő tevékenység</b-col>
          <b-col>{{ readableMainTeaor }}</b-col>

          <b-col v-if="this.createdCompany.secondaryTeaors.length > 0">További tevékenységi körök</b-col>
          <b-col v-if="this.createdCompany.secondaryTeaors.length > 0">
            <div class="mb-1" v-for="teaor in readableSecondaryTeaors" :key="teaor">
              {{ teaor }}
            </div>
          </b-col>

          <b-col>Tervezett nettó árbevétel (2023)</b-col>
          <b-col>{{ numberWithDots(Number(this.createdCompany.income)) + ' HUF' }}</b-col>

          <b-col>Tervezett mérlegfőösszeg (2023)</b-col>
          <b-col>{{ numberWithDots(Number(this.createdCompany.balanceSheetTotal)) + ' HUF' }}</b-col>

          <b-col>Tervezett export árbevétel (2023)</b-col>
          <b-col>{{ numberWithDots(Number(this.createdCompany.latestExportRevenue)) + ' HUF' }}</b-col>

          <b-col>Tervezett cég forma</b-col>
          <b-col>{{ companyName }}</b-col>

          <b-col>Átlagos statisztikai létszám</b-col>
          <b-col>{{ this.createdCompany.headCount + ' fő' }}</b-col>

          <b-col>Cég tervezett székhelye</b-col>
          <b-col>{{ readableAddress }}</b-col>

          <b-col v-if="this.createdCompany.sites.length > 0">Cég tervezett telephelye/telephelyei</b-col>
          <b-col v-if="this.createdCompany.sites.length > 0">
            <div class="mb-1" v-for="zip in readableSites" :key="zip">
              {{ zip }}
            </div></b-col
          >
        </b-row>
      </div>
    </b-col>
  </b-container>
</template>

<script>
import { mapGetters } from 'vuex'
import { gfoOptions } from '../FundCreation/utils/gfoOptions'
import zipCodes from '../../components/zipCodeSelector/zipCodes'
import teaorList from '../../components/TeaorSelector/teaor'

export default {
  components: {},
  data() {
    return {
      createdCompany: {},
      gfoOptions: gfoOptions
    }
  },
  computed: {
    ...mapGetters(['fundMapCompany']),
    companyName() {
      return this.gfoOptions.find(x => x.item === this.createdCompany.form).name
    },
    readableMainTeaor() {
      const teaorWithName = teaorList
        .map(data => {
          if (data.teaorValue === this.createdCompany.mainTeaor) {
            return data.labelText
          }
        })
        .filter(x => x !== undefined)

      return teaorWithName[0]
    },
    readableSecondaryTeaors() {
      const filteredTeaorWithNamesArray = this.createdCompany.secondaryTeaors.map(row => {
        const teaorWithNamesArray = teaorList.map(data => {
          if (data.teaorValue === row.teaorCode) {
            return data.labelText
          }
        })
        return teaorWithNamesArray.filter(x => x !== undefined)[0]
      })

      return filteredTeaorWithNamesArray
    },
    readableSites() {
      const filteredZipWithNamesArray = this.createdCompany.sites.map(row => {
        const zipWithNamesArray = zipCodes.map(data => {
          if (data.zip === row.zipCode) {
            return data.name
          }
        })
        return zipWithNamesArray.filter(x => x !== undefined)[0]
      })

      return filteredZipWithNamesArray
    },
    readableAddress() {
      const addressWithName = zipCodes
        .map(data => {
          if (data.zip === this.createdCompany.address) {
            return data.name
          }
        })
        .filter(x => x !== undefined)

      return addressWithName[0]
    }
  },
  methods: {
    goToEditImaginaryCompany() {
      this.$router.push({
        name: 'FundMapCreateImaginaryCompany'
      })
    },
    addCompany(key, value) {
      this.$store.dispatch('setFundMapCompanyAction', { [key]: value })
    },
    goToFundMap() {
      this.addCompany('imaginaryCompany', {
        ...this.createdCompany,
        companyId: this.fundMapCompany.imaginaryCompany.companyId
      })
      this.$router.push('/fund-map/search')
    },
    numberWithDots(number) {
      if (!this.fieldIsEmpty(number)) {
        return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
      }
    },
    fieldIsEmpty: function(field) {
      return field === '' || field === null || field === undefined
    }
  },
  created() {
    if (!this.fundMapCompany) {
      this.$router.push('/fund-map')
    }
  },
  mounted() {
    this.createdCompany = this.fundMapCompany.imaginaryCompany.companyData || this.fundMapCompany.imaginaryCompany

    window.onbeforeunload = function(e) {
      e.returnValue = ''
      return ''
    }
  },

  beforeDestroy() {
    window.onbeforeunload = null
  }
}
</script>

<style scoped>
.created-company-title {
  font-size: 64px;
  font-weight: 800;
  line-height: 72px;
}
.created-company-details {
  background-color: white;
  color: var(--color-gray-04);
  text-align: left;
  padding-right: 15px;
  padding-left: 15px;
  padding-bottom: 7px;
}

.created-company-details .col {
  margin-bottom: 0px !important;
  padding: 15px;
}

.created-company-details > div > .col {
  margin-top: 7px;
}

.created-company-details > div > .col:nth-child(odd) {
  color: var(--color-gray-04);
  font-weight: bold;
}

.created-company-details > div > .col:nth-child(4n + 3),
.created-company-details > div > .col:nth-child(4n + 4) {
  background-color: var(--color-lightgreen);
}

.created-company-details-vali-hollow-logo {
  position: relative;
  overflow: hidden;
}

@media (max-width: 993px) {
  .created-company-details-holder {
    padding-left: 0;
    padding-right: 0;
  }

  .created-company-details {
    border: 0px !important;
  }
}
</style>
